import type { Time, TimeRange } from "@adrekic/fieldsjson"
import { getUTCMinuteOfDay, isTimeInRange } from "@overmap-ai/forms"

import { FilterModifier } from "./FilterModifier"

export const TimeEqualsFilterModifier = FilterModifier.create<Time, Time>({
	id: "time-equals",
	getApplyFn: (filterValue) => (value) => value === filterValue,
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const TimeNotEqualsFilterModifier = FilterModifier.create<Time, Time>({
	id: "time-not-equals",
	getApplyFn: (filterValue) => (value) => value !== filterValue,
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const TimeBeforeFilterModifier = FilterModifier.create<Time, Time>({
	id: "time-before",
	getApplyFn: (filterValue) => {
		const filterMinute = getUTCMinuteOfDay(filterValue)
		return (value) => getUTCMinuteOfDay(value) < filterMinute
	},
	render: () => "before",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const TimeAfterFilterModifier = FilterModifier.create<Time, Time>({
	id: "time-after",
	getApplyFn: (filterValue) => {
		const filterMinute = getUTCMinuteOfDay(filterValue)
		return (value) => getUTCMinuteOfDay(value) > filterMinute
	},
	render: () => "after",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const TimeRangeInFilterModifier = FilterModifier.create<Time, TimeRange>({
	id: "time-range-in",
	getApplyFn: (filterValue) => (value) => isTimeInRange(value, filterValue),
	render: () => "in between",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const TimeRangeNotInFilterModifier = FilterModifier.create<Time, TimeRange>({
	id: "time-range-not-in",
	getApplyFn: (filterValue) => (value) => !isTimeInRange(value, filterValue),
	render: () => "not in between",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
